// extracted by mini-css-extract-plugin
export default {"heading":"CausesPolicyPage_heading__rtj9i","contentHeading":"CausesPolicyPage_contentHeading__Pt5+J","content":"CausesPolicyPage_content__xmP7m"};